import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterAdministrationComponent } from './component/filter-administration.component';
import { MaterialModule } from '@sdbn/appclient';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { DictionaryModule } from '@sdbn/appclient';
import { FilterEditorComponent } from './component/filter-editor/filter-editor.component';
import { NodeEditorComponent } from './component/node-editor/node-editor.component';
import { DetailsEditorWrapperComponent } from './component/details-editor/details-editor-wrapper.component';
import { FilterConditionComponent } from './component/filter-condition/filter-condition.component';
import { FilterConditionsComponent } from './component/condition-types/condition-types.component';
import { CarrierConditionEditorComponent } from './component/details-editor/transport/carrier-condition-editor/carrier-condition-editor.component';
import { FilterNodeEditorComponent } from './component/details-editor/filter-node-editor/filter-node-editor.component';
import { String1ConditionEditorComponent } from './component/details-editor/transport/string1-condition-editor/string1-condition-editor.component';
import { String2ConditionEditorComponent } from './component/details-editor/transport/string2-condition-editor/string2-condition-editor.component';
import { TransportOptionConditionEditorComponent } from './component/details-editor/transport/transport-option-condition-editor/transport-option-condition-editor.component';
import { EmptyNodeEditorComponent } from './component/details-editor/transport/empty-node-editor/empty-node-editor.component';
import { CurrentStationLocationEditorComponent } from './component/details-editor/transport/current-station-location-editor/current-station-location-editor.component';
import { CurrentStationTypeEditorComponent } from './component/details-editor/transport/current-station-type-editor/current-station-type-editor.component';
import { CurrentPositionEditorComponent } from './component/details-editor/transport/current-position-editor/current-position-editor.component';
import { NextProcessingPositionEditorComponent } from './component/details-editor/transport/next-processing-position-editor/next-processing-position-editor.component';
import { PositionInRouteEditorComponent } from './component/details-editor/transport/position-in-route-editor/position-in-route-editor.component';
import { ProcessingStatusEditorComponent } from './component/details-editor/transport/processing-status-editor/processing-status-editor.component';
import { OpenTaksOfTypeEditorComponent } from './component/details-editor/transport/open-task-editor/open-task-editor.component';
import { TransportStatusEditorComponent } from './component/details-editor/transport/transport-status-editor/transport-status-editor.component';
import { OrderReferenceEditorComponent } from './component/details-editor/transport/order-reference-editor/order-reference-editor.component';

import { TransportTypeEditorComponent } from './component/details-editor/transport/transport-type-editor/transport-type-editor.component';
import { CommonLayoutModule, CommonTranslationModule, CommonUIModule } from '@sdbn/common';
import { TableColumnEditorModule } from 'src/tmc-common/components/table-column-editor/table-column-editor.module';
import { TransportScopeEditorComponent } from './component/details-editor/transport/transport-scope/transport-scope-editor.component';
import { FilterMailScheduleComponent } from './component/filter-mail-schedule/filter-mail-schedule.component';
import { FilterMailScheduleEditorComponent } from './component/filter-mail-schedule-editor/filter-mail-schedule-editor.component';
import { VisitorRoleConditionEditorComponent } from './component/details-editor/visitor/visitor-role-condition-editor/visitor-role-condition-editor.component';
import { VisitorVisitEndConditionEditorComponent } from './component/details-editor/visitor/visitor-visit-end-condition-editor/visitor-visit-end-condition-editor.component';
import { HasSupplementaryEquipmentConditionEditorComponent } from './component/details-editor/common/visitor-has-supplementary-equipment-condition-editor/has-supplementary-equipment-condition-editor.component';
import { CargoPositionConditionEditorComponent } from './component/details-editor/transport/cargo-position-condition-editor/cargo-position-condition-editor.component';
import { WeekdayEditorComponent } from './component/details-editor/transport/weekday-editor/weekday-editor.component';
import { HoursConditionEditorComponent } from './component/details-editor/transport/hours-condition-editor/hours-condition-editor.component';




@NgModule({
  declarations: [
    FilterAdministrationComponent,
    FilterEditorComponent,
    DetailsEditorWrapperComponent,
    FilterConditionsComponent,
    NodeEditorComponent,
    FilterConditionComponent,
    CarrierConditionEditorComponent,
    HoursConditionEditorComponent,
    String1ConditionEditorComponent,
    String2ConditionEditorComponent,
    TransportOptionConditionEditorComponent,
    FilterNodeEditorComponent,
    EmptyNodeEditorComponent,
    CurrentStationLocationEditorComponent,
    CurrentStationTypeEditorComponent,
    CurrentPositionEditorComponent,
    NextProcessingPositionEditorComponent,
    PositionInRouteEditorComponent,
    ProcessingStatusEditorComponent,
    OpenTaksOfTypeEditorComponent,
    TransportStatusEditorComponent,
    TransportTypeEditorComponent,
    OrderReferenceEditorComponent,
    TransportScopeEditorComponent,
    CargoPositionConditionEditorComponent,
    FilterMailScheduleComponent,
    FilterMailScheduleEditorComponent,
    VisitorRoleConditionEditorComponent,
    HasSupplementaryEquipmentConditionEditorComponent,
    VisitorVisitEndConditionEditorComponent,
    WeekdayEditorComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    HttpClientModule,
    DictionaryModule,
    TableColumnEditorModule,
    CommonTranslationModule,
    CommonUIModule,
    CommonLayoutModule
  ]
})
export class FilterAdministrationModule { }

